import React, { useState } from "react";
import { Popover, Button } from "antd";
import { FiBell, FiEye, FiPlus, FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const NotificationPopover = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const notifications = [
    {
      id: 1,
      icon: <FiEye className="w-5 h-5 text-purple-600" />,
      title: "Edward has made an invoice, waiting for review",
      subtitle: "This customer is inside the superstore categories",
      time: "2 min ago",
      color: "bg-purple-100",
    },
    {
      id: 2,
      icon: <FiEye className="w-5 h-5 text-purple-600" />,
      title: "System send to an invoice to customer",
      subtitle: "Create to invoice by Mehmet Ozsoy",
      time: "2 min ago",
      color: "bg-purple-100",
    },
    {
      id: 3,
      icon: <FiPlus className="w-5 h-5 text-green-600" />,
      title: "Added new product",
      subtitle: "Added to product by Ayoub Atbaa",
      time: "2 min ago",
      color: "bg-green-100",
    },
    {
      id: 4,
      icon: <FiEdit className="w-5 h-5 text-red-600" />,
      title: "Change to product name",
      subtitle: "Changed as Macig instate of Matrix :)",
      time: "2 min ago",
      color: "bg-red-100",
    },
    {
      id: 5,
      icon: <FiPlus className="w-5 h-5 text-green-600" />,
      title: "Added new product",
      subtitle: "Added to product by Ayoub Atbaa",
      time: "2 min ago",
      color: "bg-green-100",
    },
    {
      id: 6,
      icon: <FiEdit className="w-5 h-5 text-red-600" />,
      title: "Change to product name",
      subtitle: "Changed as Macig instate of Matrix :)",
      time: "2 min ago",
      color: "bg-red-100",
    },
  ];

  const handleShowAll = () => { 
    setOpen(false); // close popover
  };

  const content = (
    <div className="w-[420px] font-sans">
      <div className="flex justify-between items-center mb-2 px-4 pt-2">
        <h2 className="font-semibold text-lg">Notification</h2>
        <select className="border text-sm rounded px-2 py-1 w-auto min-w-fit pe-5">
          <option>This week</option>
        </select>
      </div>

      <p className="text-sm text-gray-500 px-4 mb-3">Result (211)</p>

      <div className="max-h-[300px] overflow-y-auto px-4 space-y-4 pb-2">
        {notifications.map((note) => (
          <div key={note.id} className="flex gap-3 items-start">
            <div className={`p-2 rounded-full ${note.color}`}>
              {note.icon}
            </div>
            <div>
              <p className="text-sm font-medium">{note.title}</p>
              <p className="text-xs text-gray-500">{note.subtitle}</p>
              <p className="text-[10px] text-gray-400 mt-1">{note.time}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-3 px-4 pb-3">
        <button
          onClick={handleShowAll}
          className="bg-black text-white text-sm px-4 py-2 rounded"
        >
          Show all notifications
        </button>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger={[]}
      open={open}
      onOpenChange={() => setOpen(!open)}
      placement="bottomRight"
    >
      <Button icon={<FiBell size={14} />} />
    </Popover>
  );
};

export default NotificationPopover;
